import IframeActivity from "./IframeActivity";

export default function ProjectManager() {
    return (
        <IframeActivity
            src="/activities/project-manager/index.html"
            title="Project Manager"
        />
    );
}